import './index.scss';
import '../../common/Joyride/styles.scss';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import workflowStatus from '../../../js/workflowStatus';
import sourceTypes from '../../../js/imageSourceTypes';
import { startImagingWorkflow } from '../../../js/actions/workflowActionCreators';
import ImageSourceForm from './imageSourceForm';
import { setTourEnabled } from '../../../js/actions/tourActionCreators';
import Joyride from 'react-joyride';
import { JoyrideStepStyle } from '../../common/Joyride/steps';

const steps = [{
    title: 'Create an Image',
    text: 'Images can be created from backup files or live SQL Server databases. In this example continue with <strong>‘SQL Server’</strong> selected.', // supports html tags
    selector: '.image-source-form',
    position: 'left',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle,
}];

const ImageSourcePage = React.createClass({
    propTypes: {
        setImageCreationAsStarted: PropTypes.func.isRequired,
        workflowStatus: PropTypes.oneOf(_(workflowStatus).values()).isRequired
    },
    componentWillMount: function() {
        const { workflowStatus, setImageCreationAsStarted } = this.props;
        if(workflowStatus !== workflowStatus.started) {
            setImageCreationAsStarted();
        }
    },
    getInitialState: function () {
        return {
            initialFormValues: {
                sourcetype: sourceTypes.sqlServer
            }
        };
    },
    tourCallback(value) {
        if (value && value.type === 'finished' && value.isTourSkipped) {
            this.props.setTourEnabled('dashboard', false);
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'skippedImageSource',
                    eventLabel: 'Skipped tour on image source'
                });
        }
        if (value && value.type === 'finished' && !value.isTourSkipped) {
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'finishedImageSource',
                    eventLabel: 'End of image source tour'
                });
        }
    },
    render: function () {
        return (

            <div className="content-container">
                <Joyride ref="joyride" run={this.props.tourEnabled} autoStart={true} showSkipButton={true} type="continuous" steps={steps} callback={this.tourCallback} locale={{ last: 'Next', next: 'Next', skip: 'Skip', back: 'Back' }}/>
                <ImageSourceForm initialValues={this.state.initialFormValues} />
            </div>
        );
    }
});

ImageSourcePage.title = 'Source Type';

const mapStateToProps = (state) => {
    return {
        workflowStatus: state.app.imageCreation.workflowStatus,
        tourEnabled: state.tour.dashboard
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setImageCreationAsStarted: () => {
            dispatch(startImagingWorkflow());
        },
        setTourEnabled: (tour, enabled) => {
            dispatch(setTourEnabled(tour, enabled));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageSourcePage);



// WEBPACK FOOTER //
// ./src/components/imaging/ImageSourcePage/index.jsx